export default "__VITE_ASSET__C_gbR0U7__"